// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"e7268acb","787":"bb56bcc6"}[chunkId] + ".chunk.js";
};